// 登录页面
import { Card, Tabs, Form, Input, Button, message } from 'antd'
import styles from './index.module.scss'
import Captcha from 'react-captcha-code'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getMenus, login, registerUser } from '../../store/actions/login'
import { useHistory } from 'react-router'
import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { useRef } from 'react'
import logo from '../../assets/logo4 (1).png'
import { getCompany } from '../../utils/cookie'
import request from '../../utils/request'
import { getLocationOrigin } from '../../utils/util'
import { isMcpAuthorizationUrl, saveMcpLoginResume, MCP_REQUEST_OPTIONS } from '../../utils/mcpOAuth'
export default function LoginCas() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [initKey, setInitKey] = useState('1')
  const [form] = Form.useForm()

  useEffect(() => {
    document.title = '登录'
  }, [])
  const onFinish = async (payload) => {
    setLoading(true)
    let redirect = getLocationOrigin()+ '/loginHtml'
    let url = window.location.href
    const returnUrl = new URLSearchParams(window.location.search).get('redirect')
    const mcpLogin = isMcpAuthorizationUrl(returnUrl)
    request.post('sys/login/', payload, mcpLogin ? MCP_REQUEST_OPTIONS : undefined).then((res) => {
      if (mcpLogin) {
        if (res?.data?.code !== 0 || !res.data.data?.ticket) {
          message.error('登录失败，请重试')
          setLoading(false)
          return
        }
        saveMcpLoginResume(returnUrl)
        const target = new URL(getLocationOrigin() + '/loading')
        target.searchParams.set('redirect', returnUrl)
        target.searchParams.set('ticket', res.data.data.ticket)
        window.location.replace(target.href)
        return
      }
      // res.dada.dada.ticket
      if (/redirect=([^#/?]+)/.test(url)) {
        redirect = /redirect=([^#/?]+)/.exec(url)[1]
      }
      window.location.href = decodeURIComponent(
        redirect + '?ticket=' + res.data.data.ticket
      )
    }).catch(() => {
      message.error('登录请求失败，请稍后重试')
      setLoading(false)
    })

    captchaRef.current?.click()
    // message.success('登录成功')
    setLoading(false)
    // }
  }
  //注册
  const register = async (payload) => {
    try {
      if (payload.confirmpassword !== payload.password) {
        message.error('两次密码不一致，请确认密码')
      } else {
        delete payload.confirmpassword
        setLoading(true)
        const res = await dispatch(registerUser(payload))
        if (res?.data?.code === 0) {
          message.success('注册成功，请前往登录')
          changeTab('1')
          setInitKey('1')
          form.resetFields()
        } else {
          message.error(res?.data?.msg)
        }
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  const [code, setCode] = useState('')
  const captchaRef = useRef()
  const handleChange = useCallback((e) => {
    setCode(e)
  }, [])

  const handleRef = (ref) => {
    captchaRef.current = ref.current
  }
  const handleClick = () => {
    // 主动调用click，用于更换验证码
    captchaRef.current?.click()
  }

  const changeTab = (key) => {
    console.log(key)
    setInitKey(key)
  }

  return (
    <div className={styles.root}>
      <Card className="login-container">
        <img src={logo} alt="" />
        <Tabs
          activeKey={initKey}
          defaultActiveKey={initKey}
          centered
          onChange={changeTab}
        >
          <Tabs.TabPane tab={<span>账号密码登录</span>} key="1">
            <Form
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              onFinish={onFinish}
              validateTrigger={['onBlur', 'onChange']}
              autoComplete="off"
            >
              {/* 手机号 */}
              <Form.Item
                label="用户名"
                name="user_name"
                rules={[
                  { required: true, message: '用户名不能为空' },
                  // { pattern: /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/, message: '手机号格式不对' },
                ]}
              >
                <Input placeholder="请输入用户名"></Input>
              </Form.Item>
              {/* 密码 */}
              <Form.Item
                label="密&nbsp;&nbsp; 码"
                name="password"
                rules={[
                  { required: true, message: '密码不能为空' },
                  // {
                  //   pattern:
                  //     /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/,
                  //   message: '请输入8-16位数字字母组合的密码',
                  // },
                ]}
              >
                <Input.Password
                  onCopy={() => {
                    return false
                  }}
                  onCut={() => {
                    return false
                  }}
                  placeholder="请输入密码"
                ></Input.Password>
              </Form.Item>
              {/* 验证码 */}
              {/* <Form.Item
                label="验证码"
                name="code"
                validateTrigger={['onBlur', 'onChange']}
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.reject('验证码不能为空')
                      }
                      if (value !== code) {
                        return Promise.reject('验证码错误')
                      }
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <Input
                  style={{ width: 280 }}
                  placeholder="请输入右边的验证码"
                ></Input>
              </Form.Item>
              <div
                className="cap-code"
                style={{ position: 'fixed', top: 379, right: 154 }}
              >
                <Captcha
                  charNum={4}
                  onRef={handleRef}
                  onChange={handleChange}
                />
                <div className="cap_tips">
                  <span style={{ color: 'grey' }}>看不清，</span>
                  <a href="#" onClick={handleClick}>
                    换一个
                  </a>
                </div>
              </div> */}

              <Form.Item
                wrapperCol={{ offset: 4, span: 17 }}
                className="btn-mar"
              >
                <Button block htmlType="submit" loading={loading}>
                  登录
                </Button>
              </Form.Item>
              <div className="find-password">
                <a href="#">忘记密码？</a>
              </div>
            </Form>
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab={<span>手机登录</span>} key="2">
            手机登录
          </Tabs.TabPane> */}
          <Tabs.TabPane tab={<span>注册</span>} key="2">
            <Form
              form={form}
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              onFinish={register}
              validateTrigger={['onBlur', 'onChange']}
              autoComplete="off"
            >
              {/* 手机号 */}
              <Form.Item
                label="用户名"
                name="username"
                rules={[
                  { required: true, message: '用户名不能为空' },
                  // { pattern: /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/, message: '手机号格式不对' },
                ]}
              >
                <Input placeholder="请输入用户名"></Input>
              </Form.Item>
              {/* 密码 */}
              <Form.Item
                label="密&nbsp;&nbsp; 码"
                name="password"
                rules={[
                  { required: true, message: '密码不能为空' },
                  {
                    pattern:
                      /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/,
                    message: '请输入8-16位数字字母组合的密码',
                  },
                ]}
              >
                <Input.Password
                  onCopy={() => {
                    return false
                  }}
                  onCut={() => {
                    return false
                  }}
                  placeholder="请输入密码"
                ></Input.Password>
              </Form.Item>
              <Form.Item
                label="确认密码"
                name="confirmpassword"
                rules={[
                  { required: true, message: '密码不能为空' },
                  {
                    pattern:
                      /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/,
                    message: '请输入8-16位数字字母组合的密码',
                  },
                ]}
              >
                <Input.Password
                  onCopy={() => {
                    return false
                  }}
                  onCut={() => {
                    return false
                  }}
                  placeholder="请输入密码"
                ></Input.Password>
              </Form.Item>
              <Form.Item
                wrapperCol={{ offset: 4, span: 17 }}
                className="btn-mar"
              >
                <Button block htmlType="submit" loading={loading}>
                  注册
                </Button>
              </Form.Item>
            </Form>
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab={<span>扫码登录</span>} key="3">
            扫码登录
          </Tabs.TabPane> */}
        </Tabs>
      </Card>
    </div>
  )
}
